import React, { HTMLAttributes } from 'react';
import truncate from 'truncate-markup-string';

import {
  Container,
  Quote,
} from '@uncinc/uncinc-react-kitchen-sink';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ParagraphQuote as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphQuoteProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphQuote: React.FC<ParagraphQuoteProps> = ({
  entity,
}) => {
  const paragraphQuote = entity.toJS();
  const writer = paragraphQuote.field_name[0]?.value;
  const quote = paragraphQuote.field_body[0].value || '';
  const position = paragraphQuote.field_label[0]?.value;
  const QUOTE_MAX_CHARS = 500;

  const imageStyles = paragraphQuote.field_media_item[0]?.styles;

  const src = [
    `${imageStyles?.ratio_1_1_xs || ''}`,
    `${imageStyles?.ratio_1_1_sm || ''}`,
    `${imageStyles?.ratio_1_1_sm || ''}`,
    `${imageStyles?.ratio_1_1_sm || ''}`,
  ];

  return (
    <div className="Paragraph ParagraphQuote">
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <Quote
              writer={writer}
              quote={truncate(quote, QUOTE_MAX_CHARS, '<span>', '</span>', true)}
              profileImage={src}
              position={position}
              icon="quote"
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphQuote;
